<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Tags',
	linkPrefix: '/topic/',
	variant: 'default',
	items: [{ label: 'Tag One' }],
}
const schema = defineSchema({
	title: $.text('Title'),
	linkPrefix: $.text('Link Prefix'),
	variant: $.select('Variant', [
		{ label: 'Categories', value: 'categories' },
		{ label: 'Topics', value: 'topics' },
		{ label: 'Default', value: 'default' },
	]),
	items: $.array('Items', defineSchema({
		label: $.text('Label'),
		slug: $.text('Link'),
	}), { collapsible: true }),
})
export const TagsList = defineBlock({ pickerHidden: true, thumbnail: '/block-thumbs/TagsList.svg', category: 'Listings', order: 430, name: 'TagsList', label: 'Tags List', icon: 'label', schema, defaults })
</script>
<script setup lang="ts">


const props = defineProps<{
	title?: string
	linkPrefix?: string
	variant?: 'categories' | 'topics' | 'default'
	items?: { label: string; slug?: string }[]
}>()

function linkPath(slug?: string) {
	const prefix = props.linkPrefix
	if (!slug || prefix == null || prefix === '') return ''
	return `${prefix}${slug}`
}
</script>

<template>
	<div v-if="items && items.length" class=" border-bottom py-1">
		<p v-if="title" class="">
			{{ title }}
		</p>
		<div class="" :class="`tags-${variant || 'default'}`">
			<template v-if="linkPrefix">
				<RouterLink
					v-for="item in items?.filter(entry => linkPath(entry.slug))"
					:key="item.slug"
					:to="linkPath(item.slug)"
					class=""
				>
					{{ item.label }}
				</RouterLink>
			</template>
			<template v-else>
				<span
					v-for="item in items"
					:key="item.label"
					class=""
				>
					{{ item.label }}
				</span>
			</template>
		</div>
	</div>
</template>

<style scoped>

</style>
